import React from 'react';
import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles(({ palette }) => ({
  root: {
    position: 'absolute',
    display: 'flex',
    height: '100%',
    width: '100%',
    alignItems: 'center',
    color: palette.getContrastText(palette.common.black),
    justifyContent: 'flex-start'
  },
  heroContent: {
    paddingLeft: 96,
    zIndex: 100
  }
}));

const HeroContainer = ({ children }) => {
  const classes = useStyles({})
;
  return (
    <div className={classes.root}>
      <div className={classes.heroContent}>{children}</div>
    </div>
  );
};

export default HeroContainer;
